import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Trash2 } from "lucide-react";

const Row = ({ a, checked, onToggle, testid }) => (
  <label className="flex items-center gap-2 border-t border-[#2A2E39] py-1.5 text-xs text-gray-300" data-testid={testid}>
    <input type="checkbox" checked={checked} onChange={onToggle} />
    <span className="break-all flex-1">{a.email}</span>
    <span className="text-gray-500">{a.name}</span>
    <span className="text-gray-500 w-20 text-right">{a.created_at ? new Date(a.created_at).toLocaleDateString() : "-"}</span>
    <span className="text-gray-500 w-16 text-right">{a.coach_messages} msgs</span>
  </label>
);

export const TestAccountsCard = () => {
  const [d, setD] = useState(null);
  const [sel, setSel] = useState({});
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/admin/test-accounts").then(r => {
    setD(r.data);
    setSel(Object.fromEntries(r.data.test_accounts.map(a => [a.email, true])));
  }).catch(() => {});
  useEffect(() => { load(); }, []);

  if (!d) return null;
  const chosen = Object.keys(sel).filter(k => sel[k]);
  const toggle = (em) => setSel(s => ({ ...s, [em]: !s[em] }));

  const del = async () => {
    setBusy(true);
    try {
      const r = await api.post("/admin/test-accounts/delete", { emails: chosen, confirm });
      toast.success(`Deleted ${r.data.count} test accounts.`);
      setConfirm(""); load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Couldn't delete."); }
    setBusy(false);
  };

  return (
    <div className="card-panel p-5" data-testid="test-accounts-card">
      <div className="eyebrow text-[#FD0F10]">TEST ACCOUNTS ({d.count})</div>
      <p className="text-xs text-gray-500 mt-1">Emails ending in @example.com, @example.org, @example.net or @test.com. New ones are flagged automatically, hidden everywhere, and deleted 7 days after signup. Your admin account and info@ihatemyjob.app are never listed or deleted.</p>
      <div className="mt-3 max-h-72 overflow-y-auto" data-testid="test-accounts-list">
        {d.test_accounts.map((a, i) => <Row key={a.email} a={a} checked={!!sel[a.email]} onToggle={() => toggle(a.email)} testid={`test-account-${i}`} />)}
        {d.count === 0 && <p className="text-xs text-gray-500">No test accounts.</p>}
      </div>
      {d.own_domain.length > 0 && (
        <>
          <div className="mt-4 text-xs text-gray-400">@ihatemyjob.app accounts (not selected; tick only the ones you confirm):</div>
          <div className="mt-1" data-testid="own-domain-list">
            {d.own_domain.map((a, i) => <Row key={a.email} a={a} checked={!!sel[a.email]} onToggle={() => toggle(a.email)} testid={`own-domain-account-${i}`} />)}
          </div>
        </>
      )}
      <div className="mt-4 flex flex-col sm:flex-row gap-2 sm:items-center">
        <input value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="Type DELETE" className="bg-[#0B0C0E] border border-[#2A2E39] rounded px-3 py-2 text-sm" data-testid="test-accounts-confirm" />
        <button onClick={del} disabled={busy || confirm !== "DELETE" || chosen.length === 0} className="inline-flex items-center justify-center gap-1.5 hero-accent text-white font-bold px-4 py-2 rounded disabled:opacity-40" data-testid="test-accounts-delete-btn">
          <Trash2 size={14} /> Delete {chosen.length} selected
        </button>
      </div>
    </div>
  );
};
